import { useAuth } from '@astro/auth'
import { Can } from '@astro/permissions'
import { Button, Card } from '@astro/ui'

/**
 * Reference wiring of the shared layer:
 *  - useAuth()  -> SSO session from the BFF
 *  - <Can>      -> RBAC-gated UI
 *  - <Button>   -> design-system component
 * The exact same imports work in jyotish / shop / education.
 */
export default function AccountPage() {
  const { user, status, logout } = useAuth()

  if (status !== 'authenticated' || !user) {
    return <Card>Loading your account…</Card>
  }

  return (
    <Card className="mx-auto mt-10 max-w-md space-y-4">
      <h1 className="text-xl font-semibold text-foreground">Hi, {user.name}</h1>
      <p className="text-muted">{user.email}</p>
      <p className="text-sm text-muted">Roles: {user.roles.join(', ')}</p>

      <Can permission="admin:user:impersonate" fallback={null}>
        <Button variant="outline">Admin: impersonate user</Button>
      </Can>

      <Button variant="danger" onClick={() => logout()}>
        Sign out (all apps)
      </Button>
    </Card>
  )
}
